<template>
  <ClipLoader
    :color="color || defaultColor"
    :size="size || '30px'"
  />
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader';
import colors from '@/utils/colors';

export default {
  props: {
    color: String,
    size: String,
  },
  components: {
    ClipLoader,
  },
  computed: {
    defaultColor() {
      return colors('blue');
    },
  },
};
</script>

<style>

</style>
